import { Component, NgZone, OnInit } from '@angular/core';
import { IonApp, IonRouterOutlet, IonList, IonContent, IonItem, IonLabel, IonMenu, IonHeader, IonToolbar, IonMenuToggle, IonIcon } from '@ionic/angular';
import { addIcons } from 'ionicons';
import { personOutline, personCircleOutline, businessOutline, peopleOutline, informationCircleOutline, exitOutline, keyOutline, repeatOutline } from 'ionicons/icons';
import { Platform } from '@ionic/angular';
import { Router } from '@angular/router';
import { App, URLOpenListenerEvent } from '@capacitor/app';

import { UtilsService } from './services/utils.service';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
  providers: [ UtilsService ],
  //standalone: true, // 👈 1. CRITICAL: Tells Angular 20 that this component handles its own imports!
  imports: [IonApp, IonRouterOutlet, IonContent, IonList, IonItem, IonLabel, IonMenu, IonHeader, IonToolbar, IonMenuToggle, IonIcon],
})
export class AppComponent implements OnInit {

  constructor(
    public platform: Platform,
		public utilsService: UtilsService,
    private router: Router,
    private zone: NgZone,

  ) {
      addIcons({ personOutline, personCircleOutline, businessOutline, peopleOutline, informationCircleOutline, exitOutline, keyOutline, repeatOutline });
  }

  async ngOnInit() {

      this.platform.ready().then(() => {
          // Okay, so the platform is ready and our plugins are available.
          // Here you can do any higher level native things you might need.
          //this.statusBar.styleDefault();
          //this.splashScreen.hide();
          //this.setupDeeplinks();
          //Needs time to load the list of comments before we move to the bottom
          //setTimeout(() => {
          //  this.utilsService.OneSignalInit();
          //}, 1000);

          (async () => { 
            await new Promise( resolve => setTimeout(resolve, 2000) );
            //this.utilsService.OneSignalInit();
          })();

          this.setupDeeplinks();

        });
      
  }

  setupDeeplinks() {
    App.addListener('appUrlOpen', (event: URLOpenListenerEvent) => {
      this.zone.run(() => {
        // Example: URL is https://yourdomain.com
        const domain = 'mopcorner.com';
        const path = event.url.split(domain)[1]; // Result: /details/123

        if (path) {
          this.router.navigateByUrl(path); //Uses the path as is with all parameters
          //this.router.navigate([path]);
        }
      });
    });
  }

}
